import { HStack, Link, Text } from "@chakra-ui/react";
import useTranslate from "@raiden/library/hooks/useTranslate";
import { Href } from "../../../../../components/Href";
import { Icon } from "../../../../../components/Icon";
import {
  getMenuItemAdapterType,
  getMenuItemAdapterValues,
} from "../../../../../helpers/menus/getMenuItemAdapterValues";

/**
 * @param {string} value
 * @returns {string}
 */
function getTitle(value) {
  if (value.startsWith("https://www.")) {
    return value.replace("https://www.", "");
  }
  if (value.startsWith("https://")) {
    return value.replace("https://", "");
  }
  if (value.startsWith("http://www.")) {
    return value.replace("http://www.", "");
  }
  if (value.startsWith("http://")) {
    return value.replace("http://", "");
  }
  return value;
}

/**
 * @typedef {Object} IconProps
 * @property {string} [size]
 * @property {string} [color]
 */
/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Configuration").ConfigurationMenuItem} menuItem
 * @property {boolean} [iconOnly]
 *
 * @param {Props & IconProps} props
 */
export function MenuItem({ menuItem, iconOnly = false, ...otherprops }) {
  const translate = useTranslate();

  if (getMenuItemAdapterType({ menuItem }) === undefined) {
    return null;
  }

  const { href, target, icon } = getMenuItemAdapterValues({
    menuItem,
    translate,
  });

  if (!href) {
    return null;
  }

  if (iconOnly && !icon) {
    return null;
  }

  return (
    <Href href={href} target={target}>
      <Link as="span" color="#fff" wordBreak="break-word">
        <HStack>
          {icon && <Icon icon={icon} size="1.5rem" {...otherprops} />}

          {!iconOnly && <Text as="span">{getTitle(href)}</Text>}
        </HStack>
      </Link>
    </Href>
  );
}
